import React, { Component } from 'react'
import '../../style/Admin/ScannerReportPage.css'
// import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
// import BootstrapTable from 'react-bootstrap-table-next';
class ScannerReportPage extends Component {

    constructor(props) {
        super(props);
        this.state={
            data:[]
        }
    }
    componentDidMount() {
    }
    render() {
        // const columns = [
        //     {
        //         dataField: 'id',
        //         text: 'id'
        //     }
        // ];
        return (
            <div>

                <label className="title">
                       Scanner Report
                </label>
                <div>
                    {/*<BootstrapTable keyField='id' data={ this.state.data } columns={ columns } />*/}
                </div>
            </div>
        );
    }
}

export default ScannerReportPage ;

